export default __webpack_public_path__ + "static/media/orangeswirl.4ad4a877.svg";